export const standards = [
  "ISO 9001: 2015",
  "ISO 45001: 2018",
  "ISO 14001: 2015",
  "ISO 9001: 2015 + ISO 45001: 2018",
  "ISO 45001: 2018 + ISO 14001: 2015",
  "ISO 9001: 2015 + ISO 14001: 2015",
  "ISO 9001: 2015 + ISO 45001: 2018 + ISO 14001: 2015",
];
